import { useState } from "react";
import Reveal from "./Reveal.jsx";

const initialForm = {
  fullName: "",
  email: "",
  phone: "",
  eventType: "",
  message: "",
};

export default function Contact() {
  const [form, setForm] = useState(initialForm);
  const [note, setNote] = useState({ text: "", error: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { fullName, email, phone, message } = form;

    if (!fullName.trim() || !email.trim() || !phone.trim() || !message.trim()) {
      setNote({
        text: "Please fill in the required fields so we can reach you.",
        error: true,
      });
      return;
    }

    setNote({
      text: `Thank you, ${fullName.split(" ")[0]}! Your inquiry has been received — our team will reach out within 24 hours.`,
      error: false,
    });
    setForm(initialForm);
  };

  return (
    <section className="contact" id="contact">
      <div className="container contact-grid">
        <Reveal className="contact-info">
          <p className="eyebrow">Get In Touch</p>
          <h2 className="section-title">
            Let's Plan Something
            <br />
            Unforgettable
          </h2>
          <p className="contact-lead">
            Tell us about your occasion and our planning team will reach out
            within 24 hours with next steps and availability.
          </p>

          <ul className="contact-details">
            <li>
              <span className="contact-icon" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <rect
                    x="2"
                    y="4"
                    width="16"
                    height="12"
                    rx="1.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                  <path
                    d="M2.5 5 L10 11 L17.5 5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.2"
                  />
                </svg>
              </span>
              <div>
                <span className="contact-label">Email us</span>
                <a href="mailto:admin@zafwaroyaleevents.online">
                  admin@zafwaroyaleevents.online
                </a>
              </div>
            </li>
            <li>
              <span className="contact-icon" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d="M4 3 h3 l2 4 -2 1.3 a10 10 0 0 0 5 5 L13 11 l4 2 v3 a2 2 0 0 1 -2.2 2 A15 15 0 0 1 2 4.2 A2 2 0 0 1 4 3 Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.1"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <div>
                <span className="contact-label">Call us</span>
                <a href="tel:+919876543210">+97143232186</a>
              </div>
            </li>
            <li>
              <span className="contact-icon" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <circle
                    cx="10"
                    cy="10"
                    r="8.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.1"
                  />
                  <circle cx="10" cy="10" r="1.4" fill="currentColor" />
                </svg>
              </span>
              <div>
                <span className="contact-label">Studio</span>
                <span>
                  Zafwa Royale Events Management LLC
                  <br />
                  #702 7th floor Al waleed Building Al Rolla Street Bur Dubai
                </span>
              </div>
            </li>
          </ul>

          <div className="social-row">
            <a href="#" aria-label="Instagram" className="social-icon">
              <svg width="18" height="18" viewBox="0 0 18 18">
                <rect
                  x="1.5"
                  y="1.5"
                  width="15"
                  height="15"
                  rx="4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.2"
                />
                <circle
                  cx="9"
                  cy="9"
                  r="4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.2"
                />
                <circle cx="13.3" cy="4.7" r="1" fill="currentColor" />
              </svg>
            </a>
            <a href="#" aria-label="Facebook" className="social-icon">
              <svg width="18" height="18" viewBox="0 0 18 18">
                <circle
                  cx="9"
                  cy="9"
                  r="7.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.2"
                />
                <path
                  d="M10.5 6.2h1.3V4H10.3c-1.5 0-2.4 1-2.4 2.5v1.3H6.5v2h1.4V15h2V9.8h1.5l.3-2H9.9V6.6c0-.3.2-.4.6-.4Z"
                  fill="currentColor"
                />
              </svg>
            </a>
            <a href="#" aria-label="Pinterest" className="social-icon">
              <svg width="18" height="18" viewBox="0 0 18 18">
                <circle
                  cx="9"
                  cy="9"
                  r="7.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.2"
                />
                <path
                  d="M8.6 13.3c-.5-2 1.4-2 1.6-3.8.2-1.7-1-2.7-2.5-2.5-1.8.2-2.8 2-2.3 3.7.1.4-.1.5-.4.7-1.3-.6-1.9-2.7-1.1-4.2 1-1.9 3.6-2.5 5.5-1.7 2 .8 2.7 3.1 1.7 5-.6 1.2-1.9 2-3.1 1.8"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                />
              </svg>
            </a>
          </div>
        </Reveal>

        <Reveal
          as="form"
          className="contact-form"
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="form-row">
            <div className="field">
              <input
                type="text"
                id="fullName"
                name="fullName"
                placeholder=" "
                value={form.fullName}
                onChange={handleChange}
                required
              />
              <label htmlFor="fullName">Full name</label>
            </div>
            <div className="field">
              <input
                type="email"
                id="email"
                name="email"
                placeholder=" "
                value={form.email}
                onChange={handleChange}
                required
              />
              <label htmlFor="email">Email address</label>
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder=" "
                value={form.phone}
                onChange={handleChange}
                required
              />
              <label htmlFor="phone">Phone number</label>
            </div>
            <div className="field">
              <input
                type="text"
                id="eventType"
                name="eventType"
                placeholder=" "
                value={form.eventType}
                onChange={handleChange}
              />
              <label htmlFor="eventType">Occasion (e.g. Wedding)</label>
            </div>
          </div>
          <div className="field">
            <textarea
              id="message"
              name="message"
              rows="4"
              placeholder=" "
              value={form.message}
              onChange={handleChange}
              required
            ></textarea>
            <label htmlFor="message">Tell us about your event</label>
          </div>
          <button type="submit" className="btn btn-gold btn-block">
            Send Inquiry
          </button>
          <p
            className="form-note"
            role="status"
            style={{ color: note.error ? "#e08e8e" : "" }}
          >
            {note.text}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
